const route = (ean = ':ean') => `/tyre/${ean}`;

export default route;

